module.exports = __webpack_public_path__ + "img/reportedChecklists.8058df48.svg";